import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { WorkshopLocationMap } from '@application/common/enums/workshop-location';
import { deleteArticleLocationStockAsync, getAllArticleLocationStockByArticleIdAsync, getArticleLocationStockByIdAsync } from '@application/features/articles/ArticleThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import ModalPopup from '@ui/components/VnModal';
import { useEffect, useState } from 'react';
import AddArticleLocationStockForm from './addArticleLocationStockForm';
import VnButton from '@ui/components/VnButton';
import { trashOutline } from 'ionicons/icons';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import { handleRolePermission } from '@infrastructure/helpers';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
const ArticleLocationStockTable = ({ formData, isStockTabBold }) => {
    const dispatch = useAppDispatch();
    const [isArticleLocationUpdateFormOpen, SetIsArticleLocationUpdateFormOpen] = useState(false);
    const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
    const [selectedArticleLocationStockId, setSelectedArticleLocationStockId] = useState(null);
    const { articleLocationStocks } = useAppSelector((state) => state.artical);
    useEffect(() => {
        if (formData.id) {
            dispatch(getAllArticleLocationStockByArticleIdAsync(formData.id))
                .unwrap()
                .then((res) => {
                if (isStockTabBold && res.length > 0) {
                    isStockTabBold(true);
                }
                else {
                    isStockTabBold && isStockTabBold(false);
                }
            });
        }
    }, [formData.id]);
    const onRowClick = (id) => {
        dispatch(getArticleLocationStockByIdAsync(id))
            .unwrap()
            .then(() => {
            SetIsArticleLocationUpdateFormOpen(true);
        });
    };
    const oncloseClicked = () => {
        SetIsArticleLocationUpdateFormOpen(false);
    };
    const deleteArticleLocationItem = (id) => {
        setSelectedArticleLocationStockId(id);
        setIsDeleteConfirmOpen(true);
    };
    const onDeleteClicked = () => {
        if (selectedArticleLocationStockId != null) {
            dispatch(deleteArticleLocationStockAsync(selectedArticleLocationStockId))
                .unwrap()
                .then(() => {
                if (formData.id) {
                    dispatch(getAllArticleLocationStockByArticleIdAsync(formData.id))
                        .unwrap()
                        .then((res) => {
                        if (isStockTabBold && res.length > 0) {
                            isStockTabBold(true);
                        }
                        else {
                            isStockTabBold && isStockTabBold(false);
                        }
                    });
                }
            });
            setIsDeleteConfirmOpen(false);
        }
    };
    const onCancelDeleteClicked = () => {
        setIsDeleteConfirmOpen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'custom-table-container', children: _jsx("div", { className: 'vn-table-container', children: _jsx("div", { className: 'vn-main', children: _jsxs("table", { className: 'table', children: [_jsx("thead", { className: 'vn-table-thead', children: _jsxs("tr", { className: 'vn-custom-grid-header-card', children: [_jsx("th", {}), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Locatie" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Voorraad" }) })] }) }), _jsx("tbody", { className: 'vn-table-tbody', children: articleLocationStocks &&
                                        articleLocationStocks?.map((article) => (_jsxs("tr", { style: { cursor: 'pointer' }, onClick: () => {
                                                if (handleRolePermission(Permission.ARTIKELEN, PermissionType.Delete)) {
                                                    onRowClick(article.id);
                                                }
                                            }, children: [_jsx("td", { children: _jsx(VnButton, { type: 'button', mode: 'danger', size: 'sm', customClassName: 'Vn-grid-delete-button', icon: trashOutline, onClick: (e) => {
                                                            e.stopPropagation();
                                                            if (handleRolePermission(Permission.ARTIKELEN, PermissionType.Update)) {
                                                                deleteArticleLocationItem(article.id);
                                                            }
                                                        } }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: WorkshopLocationMap.get(article.workshopLocationId) }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: article.stock }) })] }, article.id))) })] }) }) }) }), _jsx(ModalPopup, { title: 'Update Voorraad', content: _jsx(AddArticleLocationStockForm, { onClose: oncloseClicked, formData: formData, updateCase: true }), onOpen: isArticleLocationUpdateFormOpen, onClose: () => oncloseClicked(), modalWidth: 'lg' }), _jsx(VnConfirmationModel, { title: 'Wilt u deze voorraad verwijderen?', onCancel: () => onCancelDeleteClicked(), onConfirm: () => onDeleteClicked(), onOpen: isDeleteConfirmOpen })] }));
};
export default ArticleLocationStockTable;
